export const APP_VERSION_FILE_PATH = '/version.json';

export const APP_UPDATE_NOTIFICATION_CLASS = 'app-update-notification';

export const APP_UPDATE_POLL_INTERVAL_MS = 5 * 60 * 1000;

export const APP_UPDATE_MIN_CHECK_GAP_MS = 60 * 1000;

export const APP_UPDATE_MAX_FETCH_FAILURES = 3;

export const APP_UPDATE_RELOAD_COOLDOWN_MS = 60 * 1000;

export const APP_UPDATE_SILENT_RELOAD_AWAY_MS = 30 * 60 * 1000;

export const STALE_BUILD_ERROR_PATTERN =
  /ChunkLoadError|Loading chunk .+ failed|Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i;
